// Centralised brand logomark. Renders just the floral mark icon (no wordmark).
// Use BrandmarkWithWordmark for the full combination mark.
export default function Brandmark({ size = 36, className = "" }) {
  const px = typeof size === "number" ? `${size}px` : size;
  return (
    <img
      src="/favicon.svg"
      alt="ThatGantt"
      width={size}
      height={size}
      style={{ width: px, height: px }}
      className={`rounded-[6px] object-contain select-none ${className}`}
      draggable={false}
    />
  );
}

// Horizontal combination mark — mark + "thatGantt" wordmark. Use in top navs.
export function BrandmarkHorizontal({ height = 32, className = "" }) {
  const h = typeof height === "number" ? `${height}px` : height;
  return (
    <img
      src="/thatgantt-mark.png"
      alt="ThatGantt"
      style={{ height: h, width: "auto" }}
      className={`object-contain select-none ${className}`}
      draggable={false}
    />
  );
}

// Vertical combination mark — used in footers and auth shells.
export function BrandmarkVertical({ size = 120, className = "" }) {
  const s = typeof size === "number" ? `${size}px` : size;
  return (
    <img
      src="/thatgantt-mark-vertical.png"
      alt="ThatGantt"
      style={{ width: s, height: "auto" }}
      className={`object-contain select-none ${className}`}
      draggable={false}
    />
  );
}
